import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import User from 'components/framework/models/User';
import IdeaUser from 'components/framework/models/IdeaUser';

export class ContributorshipName extends Field {
  static subqueriesForModel() {
    return {
      contributorship: User.select(['name', 'email']).union(
        IdeaUser.select(['name', 'email'])
      ),
    };
  }

  get title() {
    return 'Created by';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Created by user' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.contributorship?.name) {
      return {
        text: record.contributorship.name,
      };
    } else if (record?.contributorship?.email) {
      return { text: record.contributorship.email };
    }

    return {};
  }
}
